import React from 'react';
var EntityMapperContext = /*#__PURE__*/React.createContext();
export default EntityMapperContext;